import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import type { UploadProps } from 'antd';
import { Upload, Input, Space, Select, Button, message } from 'antd';
import { apiGetMineInfo, apiResetPassword, apiEditMineInfo, apiResetEmail, apiResetPhone, apiCheckPhone, apiGetCaptchaWord, apiPostEmailCaptcha, apiCheckEmail, apiPostPhoneCaptcha } from '../../request/api'
import SliderOnly from '../slider';
import { imageUrl, zeusApp, basciUrl } from '../../request/index'
import { CheckOutlined, CloseCircleOutlined, UploadOutlined } from '@ant-design/icons';
import { validateEmail, validatePhone } from '../../assets/js/validators'
import { useCustomData } from '../../pages/context/mineCustomDataProvider';

interface MineInformationProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
    refreshMineInfo: () => void; // 接收从Mine组件传递的回调函数

}
interface MineInfo {
    name: string;
    headImg: string;
    accountName: string;
    email: string;
    phone: string
}

const MineInformation: React.FC<MineInformationProps> = ({ handleViewChange, data, refreshMineInfo }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [notifiNum, setNotifiNum] = useState(0)
    const [rightState, setRightState] = useState(0)
    const [rightWant, setRightWant] = useState(0)
    const [phone, setPhone] = useState('')
    const [verify, setVerify] = useState('')
    const [verifyCode, setVerifyCode] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [newpassword, setNewPassword] = useState('')

    const [countdown, setCountdown] = useState(0);

    const [messageApi, contextHolder] = message.useMessage();
    const [isSuccess, setIsSuccess] = useState(false)
    const [isButtonLoading, setIsButtonLoading] = useState(false);

    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [headImage, setHeadeImage] = useState('')
    const token = window.localStorage.getItem('userToken') || window.sessionStorage.getItem('userToken');
    const [error, setError] = useState<string | undefined | null>(null);
    const [mineInfo, setMineInfo] = useState<MineInfo>({
        name: '',
        headImg: '',
        accountName: '',
        email: '',
        phone: '',
    });

    const { getValue } = useCustomData();
    const accountManager = getValue('accountManager');
    const secondRestart = getValue('secondRestart');
    const mineInfoff = getValue('mineInfo');
    const accountInfo = getValue('accountInfo');
    const canPassword = getValue('canPassword');
    const headerImage = getValue('headerImage');
    const infoName = getValue('infoName');
    const plaseInner = getValue('plaseInner');
    const changeInfof = getValue('changeInfo');
    const bindAccount = getValue('bindAccount');
    const nownotHaveEmail = getValue('nownotHaveEmail');
    const riddy = getValue('riddy');
    const notRiddy = getValue('notRiddy');
    const notBindPhone = getValue('notBindPhone');
    const change = getValue('change');
    const setting = getValue('setting');
    const accountPassword = getValue('accountPassword');
    const changeHeaderImage = getValue('changeHeaderImage');
    const comfirm = getValue('comfirm');
    const IdentityVerification = getValue('IdentityVerification');
    const isbenren = getValue('isbenren');
    const plaseInputEmailPhone = getValue('plaseInputEmailPhone');
    const plaseInputyanzhengma = getValue('plaseInputyanzhengma');
    const changePhone = getValue('changePhone');
    const interNewPhone = getValue('interNewPhone');
    const plaseEnterNewPhone = getValue('plaseEnterNewPhone');
    const plaseEnterNewEmail = getValue('plaseEnterNewEmail');
    const plaseChooseNewEmail = getValue('plaseChooseNewEmail');
    const changePassword1 = getValue('changePassword');
    const plaseEnterNewPassword = getValue('plaseEnterNewPassword');
    const plaseRestartPassword = getValue('plaseRestartPassword');
    const sendInfowsss = getValue('sendInfowsss');
    const getInnnfasscuess = getValue('getInnnfasscuess');
    const enterInfoError = getValue('enterInfoError');
    const resetPasswordSuccess = getValue('resetPasswordSuccess');
    const twoPassword = getValue('twoPassword');
    const inputError = getValue('inputError');
    const settingPhoneSuccess = getValue('settingPhoneSuccess');
    const settingEmailSuccess1 = getValue('settingEmailSuccess1');
    const tdrage = getValue('tdrage');
    const inforScuess = getValue('inforScuess');


    const [identifyingString, setIdentifyingString] = useState(sendInfowsss)



    const options = [
        {
            value: '+86',
            label: '+86',
        },
        {
            value: '+72',
            label: '+72',
        },
    ];
    useEffect(() => {
        apiGetMineInfo().then(res => {
            setMineInfo(res.data.data)
            refreshMineInfo();
        }).catch(err => {
            console.log(err)
        });
    }, [token]);

    useEffect(() => {
        if (countdown > 0) {
            const timer = setTimeout(() => {
                setCountdown(countdown - 1);
            }, 1000);

            // 清除定时器，防止内存泄漏
            return () => clearTimeout(timer);
        } else if (countdown === 0) {
            // 倒计时结束，启用按钮
            setIsButtonDisabled(false);
        }
    }, [countdown]);


    const handleGetCode = () => {
        let intal = ""
        if (rightState == 2) {
            intal = verify
        } else if (rightState == 3) {
            intal = phone
        } else {
            intal = email
        }
        console.log(intal)
        if (!isSuccess) {
            messageApi.open({
                type: 'error',
                content: '请进行验证',
            });
        } else {
            apiGetCaptchaWord({
                key: intal
            }).then(res => {
                console.log(res)
                setIsButtonLoading(true)
                setTimeout(() => {
                    if (rightState == 2) {
                        if (validateEmail(verify)) {
                            apiPostEmailCaptcha({
                                captcha: res.data.data,
                                email: intal
                            }, {
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                }
                            }).then(emailres => {
                                console.log(emailres)
                                messageApi.open({
                                    type: 'success',
                                    content: emailres.data.data,
                                });
                                setIsButtonDisabled(true);
                                setCountdown(60);
                                setIsButtonLoading(false)
                            })
                        } else if (validatePhone(verify)) {
                            apiPostPhoneCaptcha({
                                captcha: res.data.data,
                                phone: intal
                            }, {
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                }
                            }).then(emailres => {
                                console.log(emailres)
                                messageApi.open({
                                    type: 'success',
                                    content: emailres.data.data,
                                });
                                setIsButtonDisabled(true);
                                setCountdown(60);
                                setIsButtonLoading(false)
                            })
                        }
                    } else if (rightState == 3) {
                        apiPostPhoneCaptcha({
                            captcha: res.data.data,
                            phone: intal
                        }, {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            }
                        }).then(emailres => {
                            messageApi.open({
                                type: 'success',
                                content: getInnnfasscuess,
                            });
                            console.log(emailres)
                            setIsButtonDisabled(true);
                            setCountdown(60);
                            setIsButtonLoading(false)
                        })
                    } else {
                        apiPostEmailCaptcha({
                            captcha: res.data.data,
                            email: intal
                        }, {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            }
                        }).then(emailres => {
                            messageApi.open({
                                type: 'success',
                                content: getInnnfasscuess,
                            });
                            console.log(emailres)
                            setIsButtonDisabled(true);
                            setCountdown(60);
                            setIsButtonLoading(false)
                        })
                    }
                }, 3000);
            }).catch(err => {
                console.log(err)
            });
        }

    }

    const inputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        console.log(notifiNum)
        console.log(value)
        if (rightState == 2) {
            setVerify(value)
        } else if (rightState == 3) {
            setPhone(value)
        } else {
            setEmail(value)
        }
    };

    const verifyCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        console.log(value)
        setVerifyCode(value)
    }

    const changePassword = () => {
        console.log(verify)
        if (error) {
            message.open({
                type: 'error',
                content: enterInfoError,
            })
        } else {
            apiResetPassword({
                password: password,
                account: verify,
            }).then(res => {
                console.log(res)
                messageApi.open({
                    type: 'success',
                    content: resetPasswordSuccess,
                });
                setRightState(0)
            })
        }
    }

    const changePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        console.log(value)
        setPassword(value)
        if (newpassword !== value) {
            setError(twoPassword)
        } else {
            setError(null)
        }
    }
    const changeNewPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setNewPassword(value)
        if (value !== password) {
            setError(twoPassword)
        } else {
            setError(null)
        }
    }

    const verifyOK = () => {
        if (rightState == 2) {
            if (validateEmail(verify)) {
                apiCheckEmail({
                    email: verify,
                    emailCaptcha: verifyCode,
                }).then(res => {
                    setRightState(rightWant)
                    setVerifyCode('')
                })
            } else if (validatePhone(verify)) {
                apiCheckPhone({
                    email: verify,
                    emailCaptcha: verifyCode,
                }).then(res => {
                    setRightState(rightWant)
                    setVerifyCode('')
                })
            } else {
                message.open({
                    type: 'error',
                    content: inputError,
                })
            }
        } else if (rightState == 3) {
            apiResetPhone({
                phone: phone,
                smsCaptcha: verifyCode
            }).then(res => {
                console.log(res)
                if (res.data.ret !== '0') {
                    messageApi.open({
                        type: 'error',
                        content: res.data.msg,
                    });
                } else {
                    messageApi.open({
                        type: 'success',
                        content: settingPhoneSuccess,
                    });
                    setRightState(0)
                }
            })
        } else {
            apiResetEmail({
                email: email,
                emailCaptcha: verifyCode
            }).then(res => {
                messageApi.open({
                    type: 'success',
                    content: settingEmailSuccess1,
                });
                console.log(res)
                setRightState(0)
            })
        }
        setVerifyCode('')
        if (rightWant != 5) {
            setVerifyCode('')
        }
    }

    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newName = e.target.value;
        setMineInfo({ ...mineInfo, name: newName }); // Create a new object with updated name
    };
    //修改个人信息
    const changeInfo = () => {
        apiEditMineInfo({
            name: mineInfo.name,
            headImg: mineInfo.headImg,
        }).then(res => {
            refreshMineInfo();
        })
    }
    const requestHeaderImage = () => {
        setMineInfo({ ...mineInfo, headImg: headImage })
        setRightState(0)
    }

    const onSuccess = () => {
        setIsSuccess(true)
        // alert('滑动验证成功！');
    };

    const onError = () => {
        messageApi.open({
            type: 'error',
            content: '没有验证成功',
        });
    };
    const uploadProps: UploadProps = {
        name: 'file',
        action: `${basciUrl}/ucs/file?zeus-app=${zeusApp}&zeus-token=${token}`,
        maxCount: 1,
        headers: {
            authorization: 'authorization-text',
        },
        onChange(info) {
            console.log(info);
            if (info.file.status === 'done') {
                setHeadeImage(info.file.response.data)
                setRightState(1);
            }
        },
    };

    return (
        <div className="MineInformation">
            {contextHolder}
            <div className='notifications-header'>
                <div onClick={() => { setNotifiNum(0); setRightState(0) }} style={{ color: notifiNum == 0 ? '#33364b' : '#8a8eab' }}>{mineInfoff}</div>
                <div onClick={() => { setNotifiNum(1); setRightState(0) }} style={{ color: notifiNum == 1 ? '#33364b' : '#8a8eab' }} className='notifica-middle'>{accountManager}</div>
            </div>
            <div className="infor-content">
                {notifiNum == 0 && (
                    <div className="infor-mineinfo1">
                        <div className='infor-header'>
                            <div>{accountInfo}</div>
                            <div>{canPassword}</div>
                        </div>
                        <div className="infor-name">{mineInfo?.accountName}</div>
                        <div className='infor-header'>
                            <div>{headerImage}</div>
                        </div>
                        <div style={{ height: '105px' }} >
                            <Upload {...uploadProps}>
                                <div className="infor-image">
                                    <img src={`${imageUrl}${mineInfo.headImg}?zeus-app=${zeusApp}`} />
                                    <div className='infor-image-shadow'>
                                        <UploadOutlined className='UploadOutlined-image' />
                                    </div>
                                </div>
                            </Upload>
                        </div>
                        <div className='infor-header'>
                            <div>*{infoName}</div>
                        </div>
                        <Input
                            type="text"
                            value={mineInfo.name}
                            placeholder={plaseInner}
                            onChange={handleNameChange}
                        />
                        <div>
                            <Button className='changeInfo' onClick={changeInfo}>{changeInfof}</Button>
                        </div>
                    </div>
                )}
                {notifiNum == 1 && (
                    <div className="infor-mineinfo">
                        <div className='infor-header'>
                            <div>{bindAccount}</div>
                        </div>
                        <div className='changeInfo-content' style={{ color: themeColor }}>
                            <div className='changeInfo-content-left'>
                                {mineInfo.email && (<CheckOutlined />)}
                                {!mineInfo.email && (<CheckOutlined style={{ color: '#8a8eab' }} />)}
                            </div>
                            <div className='changeInfo-content-middle'>
                                <p>{email}</p>
                                {mineInfo.email && (<p>{mineInfo.email}</p>)}
                                {!mineInfo.email && (<p>{nownotHaveEmail}</p>)}
                            </div>
                            {mineInfo.email && (<div className='changeInfo-content-right' onClick={() => { setRightState(2); setRightWant(4); setIsSuccess(false) }}>{change}</div>)}
                            {!mineInfo.email && (<div className='changeInfo-content-right' onClick={() => { setRightState(2); setRightWant(4); setIsSuccess(false) }}>{setting}</div>)}
                        </div>
                        <div className='changeInfo-content' style={{ color: themeColor }}>
                            <div className='changeInfo-content-left'>
                                {mineInfo.accountName && (<CheckOutlined />)}
                                {!mineInfo.accountName && (<CheckOutlined style={{ color: '#8a8eab' }} />)}
                                {/* <CloseOutlined />  */}
                            </div>
                            <div className='changeInfo-content-middle'>
                                <p>{accountPassword}</p>
                                {mineInfo.accountName && (<p style={{ color: '#8a8eab', fontSize: "12px" }}>{riddy}</p>)}
                                {!mineInfo.accountName && (<p style={{ color: '#8a8eab', fontSize: "12px" }}>{notRiddy}</p>)}
                                <p></p>
                            </div>
                            <div className='changeInfo-content-right' onClick={() => { setRightState(2); setRightWant(5); setIsSuccess(false) }}>{change}</div>
                        </div>
                        <div className='changeInfo-content' style={{ color: themeColor }}>
                            <div className='changeInfo-content-left'>
                                {mineInfo.phone && (<CheckOutlined />)}
                                {!mineInfo.phone && (<CheckOutlined style={{ color: '#8a8eab' }} />)}
                            </div>
                            <div className='changeInfo-content-middle'>
                                <p>{phone}</p>
                                {mineInfo.phone && (<p>{mineInfo.phone}</p>)}
                                {!mineInfo.phone && (<p>{notBindPhone}</p>)}
                            </div>
                            {mineInfo.phone && (<div className='changeInfo-content-right' onClick={() => { setRightState(2); setRightWant(3); setIsSuccess(false) }}>{change}</div>)}
                            {!mineInfo.phone && (<div className='changeInfo-content-right' onClick={() => { setRightState(2); setRightWant(3); setIsSuccess(false) }}>{setting}</div>)}
                        </div>
                    </div>
                )}
                {/* 编辑头像 */}
                {rightState === 1 && (
                    <div className='infor-right'>
                        <div className="infor-right-header">
                            <div>{changeHeaderImage}</div>
                            <CloseCircleOutlined onClick={() => setRightState(0)} style={{ fontSize: '20px' }} />
                        </div>
                        <div className='inforChangeImage'>
                            <div className="inforChangeImage-left">
                                <img src={`${imageUrl}${headImage}?zeus-app=${zeusApp}`} />
                            </div>
                            <div className="inforChangeImage-right">
                                <img src={`${imageUrl}${headImage}?zeus-app=${zeusApp}`} />
                            </div>
                        </div>
                        <div>
                            <Button className='changeInfo' onClick={requestHeaderImage}>{comfirm}</Button>
                        </div>
                    </div>
                )}
                {rightState === 2 && (
                    <div className='infor-right'>
                        <div className="infor-right-header">
                            <div>{IdentityVerification}</div>
                            <CloseCircleOutlined onClick={() => setRightState(0)} style={{ fontSize: '20px' }} />
                        </div>
                        <div className="littletitle">{isbenren}</div>
                        <Input className='emailInput' status={error ? 'error' : ''} value={verify} placeholder={plaseInputEmailPhone} onChange={inputChange} />

                        {error && (
                            <div style={{ color: '#e60d0d', marginTop: '2px', fontSize: '12px' }}>
                                {error}
                            </div>
                        )}
                        <div className="slider-wrapper">
                            <SliderOnly
                                width={360} // 滑动轨道宽度
                                fragmentSize={40} // 滑块宽度
                                onSuccess={onSuccess}
                                onError={onError}
                                color={themeColor}
                                tdrage={getValue('tdrage')}
                                inforScuess={getValue('inforScuess')}
                            />
                        </div>
                        <div className="phoneCheckbox">
                            <Input className='phoneInput' status={error ? 'error' : ''} value={verifyCode} placeholder={plaseInputyanzhengma} onChange={verifyCodeChange} />
                            <Button disabled={isButtonDisabled} onClick={handleGetCode} loading={isButtonLoading}
                                style={{
                                    color: isButtonDisabled ? '#e5e5ee' : 'inherit'
                                }}
                            >
                                {countdown > 0 ? `${countdown}${secondRestart}` : identifyingString}
                            </Button>
                        </div>
                        <div>
                            <Button className='changeInfo' onClick={verifyOK}>{comfirm}</Button>
                        </div>
                    </div>
                )}
                {/* 更换手机号 */}
                {rightState === 3 && (
                    <div className='infor-right'>
                        <div className="infor-right-header">
                            <div>{changePhone}</div>
                            <CloseCircleOutlined onClick={() => setRightState(0)} style={{ fontSize: '20px' }} />
                        </div>
                        <div className="littletitle">{interNewPhone}</div>
                        <Space.Compact>
                            <Select defaultValue="+86" options={options} />
                            <Input className='phoneInput' status={error ? 'error' : ''} value={phone} placeholder={plaseEnterNewPhone} onChange={inputChange} />
                        </Space.Compact>
                        <div className="slider-wrapper">
                            <SliderOnly
                                width={360} // 滑动轨道宽度
                                fragmentSize={40} // 滑块宽度
                                onSuccess={onSuccess}
                                onError={onError}
                                color={themeColor}
                                tdrage={getValue('tdrage')}
                                inforScuess={getValue('inforScuess')}
                            />
                        </div>
                        {error && (
                            <div style={{ color: '#e60d0d', marginTop: '2px', fontSize: '12px' }}>
                                {error}
                            </div>
                        )}

                        <div className="phoneCheckbox">
                            <Input className='phoneInput' status={error ? 'error' : ''} value={verifyCode} placeholder={plaseInputyanzhengma} onChange={verifyCodeChange} />
                            <Button disabled={isButtonDisabled} onClick={handleGetCode} loading={isButtonLoading}
                                style={{
                                    color: isButtonDisabled ? '#e5e5ee' : 'inherit'
                                }}
                            >
                                {countdown > 0 ? `${countdown}${secondRestart}` : identifyingString}
                            </Button>
                        </div>
                        <div>
                            <Button className='changeInfo' onClick={verifyOK}>{comfirm}</Button>
                        </div>
                    </div>
                )}
                {/* 更换邮箱 */}
                {rightState === 4 && (
                    <div className='infor-right'>
                        <div className="infor-right-header">
                            <div>{plaseEnterNewEmail}</div>
                            <CloseCircleOutlined onClick={() => setRightState(0)} style={{ fontSize: '20px' }} />
                        </div>
                        <div className="littletitle">{plaseChooseNewEmail}</div>
                        <Input className='emailInput' status={error ? 'error' : ''} value={email} placeholder={plaseEnterNewEmail} onChange={inputChange} />
                        {error && (
                            <div style={{ color: '#e60d0d', marginTop: '2px', fontSize: '12px' }}>
                                {error}
                            </div>
                        )}
                        <div className="slider-wrapper">
                            <SliderOnly
                                width={360} // 滑动轨道宽度
                                fragmentSize={40} // 滑块宽度
                                onSuccess={onSuccess}
                                onError={onError}
                                color={themeColor}
                                tdrage={getValue('tdrage')}
                                inforScuess={getValue('inforScuess')}
                            />
                        </div>
                        <div className="phoneCheckbox">
                            <Input className='phoneInput' status={error ? 'error' : ''} value={verifyCode} placeholder={plaseInputyanzhengma} onChange={verifyCodeChange} />
                            <Button disabled={isButtonDisabled} onClick={handleGetCode} loading={isButtonLoading}
                                style={{
                                    color: isButtonDisabled ? '#e5e5ee' : 'inherit'
                                }}
                            >
                                {countdown > 0 ? `${countdown}${secondRestart}` : identifyingString}
                            </Button>
                        </div>
                        <div>
                            <Button className='changeInfo' onClick={verifyOK}>{comfirm}</Button>
                        </div>
                    </div>
                )}
                {/* 更改密码 */}
                {rightState === 5 && (
                    <div className='infor-right'>
                        <div className="infor-right-header">
                            <div>{changePassword1}</div>
                            <CloseCircleOutlined onClick={() => setRightState(0)} style={{ fontSize: '20px' }} />
                        </div>
                        <div className="littletitle">{plaseEnterNewPassword}</div>
                        <Input placeholder={plaseEnterNewPassword} status={error ? 'error' : ''} onChange={changePasswordChange}></Input>
                        <Input style={{ marginTop: '24px' }} placeholder={plaseRestartPassword} status={error ? 'error' : ''} onChange={changeNewPasswordChange}></Input>
                        {error && (
                            <div style={{ color: '#e60d0d', marginTop: '2px', fontSize: '12px' }}>
                                {error}
                            </div>
                        )}
                        <div>
                            <Button className='changeInfo' onClick={changePassword}>{comfirm}</Button>
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
};


export default MineInformation;